import { render } from "./StepLoadingSkeleton.vue?vue&type=template&id=3c24e4a4"
import script from "./StepLoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./StepLoadingSkeleton.vue?vue&type=script&lang=js"
script.render = render

export default script